import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager} from "../../AudioManager";
import { Rect } from "../.././MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FontResource } from "../../ResourceManager/FontResource";
// namespace SlotGames {
	export class MayanHeroesFillingPot_2Screen extends SlotGameType1_2Screen {
	
		
		// protected override panelFactory: IPanelFactory = new MayanHeroesFillingPotPanelFactory();
		protected override helpFactory: IHelpFactory = new MayanHeroesFillingPotHelpFactory();
		//LED COLOR
		protected override ColorLed: string = "0,139,139\n";
		protected override panelColor: ButtonColors={
			backgroundButtonColor: "linear-gradient(rgb(0, 0, 0), rgb(8, 143, 143), rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%"
		};



		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "MayanHeroesFillingPot");
			this.spinnableReelsParams.topBorderWidth = 6;
			this.spinnableReelsParams.bottomBorderWidth = 6;
		}

		// public PrepareFont(resourceManager: ResourceManager) {
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/Monky Stone.ttf", "." + this.resid.ScopedResourceName("font")));
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/Monky Stone.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
		// }
	}

	//Panel Colorized
	class MayanHeroesFillingPotPanelFactory implements IPanelFactory {
		public CreateNewPanel(params: PanelParams): Panel {
			return new MayanHeroesFillingPotPanel(params);
		}
	}

	class MayanHeroesFillingPotPanel extends Panel {
		protected override ButtonBackground(): ButtonColors {
			let color: ButtonColors = {
				backgroundButtonColor: "linear-gradient(rgb(31, 75, 60),rgb(40, 77, 71), rgb(103, 146, 139),rgb(40, 77, 71),rgb(31, 75, 60)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				linearColor: "linear-gradient(to left , transparent, HoneyDew,transparent ) 0 10 100%",
			};
			return color;

		}

	}

	//Help Colorized
	class MayanHeroesFillingPotHelpFactory implements IHelpFactory {
		public CreateNewHelp(params: HelpParameters): Help {
			return new MayanHeroesFillingPotHelp(params);
		}
	}

	class MayanHeroesFillingPotHelp extends Help {
		protected override BackgroundPanel(): HelpPanelColor {
			let color: HelpPanelColor = {
				backgroundPanelColor: "linear-gradient(rgb(31, 75, 60),rgb(40, 77, 71), rgb(103, 146, 139),rgb(40, 77, 71),rgb(31, 75, 60)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			};

			return color;
		}
	}


// }
